import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export const KIND_PATH = { city: "/locations", industry: "/industries", article: "/resources", combo: "/locations" };
export const pagePath = (p) => (p.kind === "combo" ? `/locations/${p.city_slug}/${p.slug}` : `${KIND_PATH[p.kind]}/${p.slug}`);
const COLS = [["city", "Locations"], ["industry", "Industries"], ["article", "Resources"]];

let cache = null;
export const usePublishedPages = () => {
  const [pages, setPages] = useState([]);
  useEffect(() => {
    cache = cache || api.get("/public/site-pages").then((r) => r.data).catch(() => []);
    cache.then(setPages);
  }, []);
  return pages;
};

const label = (p) => (p.kind === "city" ? `${p.city}, ${p.state}` : p.kind === "industry" ? p.title.replace(/^Feasibility Studies for /i, "") : p.kind === "combo" ? `${p.industry} in ${p.city}` : p.title);

export const PublicFooter = () => {
  const pages = usePublishedPages();
  const [brand, setBrand] = useState("");
  useEffect(() => { api.get("/public/branding").then((r) => setBrand(r.data?.company_name || "")).catch(() => {}); }, []);
  return (
    <footer className="border-t border-slate-800/80 mt-10" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-sm">
        <div>
          <p className="font-display font-semibold mb-3">Feasibility studies</p>
          <ul className="space-y-2 text-slate-400">
            <li><Link to="/" className="hover:text-emerald-300">Home</Link></li>
            <li><Link to="/#pricing" className="hover:text-emerald-300">Pricing</Link></li>
            <li><Link to="/feasibility-studies" className="hover:text-emerald-300">Studies for loans</Link></li>
          </ul>
        </div>
        {COLS.map(([kind, title]) => {
          const list = pages.filter((p) => p.kind === kind);
          if (!list.length) return null;
          return (
            <div key={kind} data-testid={`footer-${kind}`}>
              <Link to={KIND_PATH[kind]} className="font-display font-semibold mb-3 block hover:text-emerald-300">{title}</Link>
              <ul className="space-y-2 text-slate-400">
                {list.slice(0, 8).map((p) => <li key={p.id}><Link to={pagePath(p)} className="hover:text-emerald-300">{label(p)}</Link></li>)}
              </ul>
            </div>
          );
        })}
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 border-t border-slate-800/80 flex flex-wrap justify-between gap-3 text-xs text-slate-500" data-testid="footer-legal">
        <p>© {new Date().getFullYear()} {brand}. All rights reserved.</p>
        <p className="max-w-xl">Feasibility studies support, but do not guarantee, financing. Credit decisions rest with the lender.</p>
      </div>
    </footer>
  );
};

export { label as pageLabel };
